import type { Cockpit, CockpitTarget, CockpitTargetSort } from './vuex';

export default {
  cockpit: null as Cockpit | null,
  targetSort: null as CockpitTargetSort,
  sortingTarget: null as CockpitTarget | null,
};
